//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Cookie from "js-cookie";

export default {
    data() {
        return {
            // slide 관련
            active: false,

	        // 현재 페이지 언어
	        currentLang : Cookie.get( this.$amConstant.AM_I18N_COOKIE_KEY ),
        };
    },
    watch: {
    	$route() {
		    this.currentLang = Cookie.get( this.$amConstant.AM_I18N_COOKIE_KEY );
	    }
    },
	mounted() {
	},
	fetch() {
    },
    computed: {
        // 패밀리 사이트 버튼 아이콘 토글
        familySiteBtnIconToggle: function() {
            if (this.active) {
                return "remove";
            }

            return "add";
        },
    },

    methods: {
        // slide toggle
        slideToggle() {
            this.active = !this.active;
        },
    },
};
